import React, { useEffect, useState } from 'react';
import './reward-item-clicked.styles.scss';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import HiddenText from '@/components/SHARED/hidden-text/hidden-text.component';
import { format } from 'date-fns';
import { useSelector } from 'react-redux';

const RewardItemClicked = ({ 
    reward,
    handleRewardModalOpen
}) => {

    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ backgroundImage, setBackgroundImage ] = useState(null);
    
    useEffect(() => {
        if (!reward) return;
        setBackgroundImage(
            (reward.display === 'reward')
            ?
            '/images/icons/treasure2-op.png'
            :
            (reward.display === 'achievement')
            ?
            '/images/icons/achievement2_cl.png'
            :
            (reward.display === 'prizepack')
            ?
            '/images/icons/prizepack2_cl.png'
            :
            (reward.display === 'purchase')
            ?
            '/images/icons/shopping-cart-frame.png'
            :
            (reward.display === 'momentum')
            ?
            '/images/icons/momentum2_wide.png'
            :
            ''
        )
    }, [reward])

    return (
        <div 
            className={`reward-item-clicked ${screenSize}`} 
            id={`reward-${reward.ts}-div`} >
            <table className='treasure-table'>
                <tbody>
                    <tr>
                        <td className='opened-treasure-td'>
                            <ImageContainer 
                                src={backgroundImage}
                                alt='open rewards icon' 
                                className='opened-treasure' />
                            <ImageContainer 
                                src={reward.icon}
                                alt='activity icon' 
                                className='activity-icon' />
                        </td>
                    </tr>
                    <tr>
                        <td className='text-td'>
                            {/* {
                                (screenSize !== 'mobile') 
                                ?
                                <span className='text'>
                                    <span className='desc'>
                                        {reward.event}
                                    </span>
                                    <br />
                                    {
                                        reward.type === 'secretCode' ? 
                                        <HiddenText 
                                            text={reward.title} 
                                            hidden={true} /> : 
                                        <span>{reward.title}<br /></span>
                                    }
                                    
                                    <span className='desc'>
                                        Earned {format(new Date(reward.ts), 'Pp')}
                                    </span>
                                </span>
                                :
                                <div className='meta'>
                                    {format(new Date(reward.ts), 'P')}
                                </div>
                            } */}
                            <div className='meta'>
                                {format(new Date(reward.ts), 'P')}
                            </div>
                            {
                                (
                                    reward.type === 'momentum' ||
                                    reward?.rewardIds?.length > 0) &&
                                <>
                                    <div className="g-space-0-5"></div>
                                    <div className='center-col'>
                                        <button 
                                            className={`g-button ${screenSize === 'mobile' ? 'tiny-btn' : 'small-btn'}`} 
                                            onClick={() => handleRewardModalOpen(reward.id)}>
                                            {
                                                (screenSize === 'mobile') 
                                                ? 'View'
                                                : (reward.type === 'momentum')
                                                ? 'View Results'
                                                : 'View Rewards'
                                            }
                                        </button>
                                    </div>
                                </>
                            }
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

export default RewardItemClicked